import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-app-terminoslegal',
  templateUrl: './modal-app-terminoslegal.component.html',
  styleUrls: ['./modal-app-terminoslegal.component.scss'],
})
export class ModalAppTerminoslegalComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
